import { useQuery, useQueryClient } from "@tanstack/react-query";

import {
  fetchListedLeadIds,
  fetchListMemberIds,
  fetchLists,
} from "./dealsCrmActions";

/** The user's lists (Supabase `groups` rows). */
export const useLists = () => {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ["deals", "lists"],
    queryFn: fetchLists,
    staleTime: 60 * 1000,
  });
  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: ["deals", "lists"] });
  return { ...query, invalidate };
};

/** source_record_ids on the selected list — resolves the list filter. */
export const useListMembers = (groupId: string) =>
  useQuery({
    queryKey: ["deals", "listMembers", groupId],
    queryFn: () => fetchListMemberIds(groupId),
    enabled: !!groupId,
    staleTime: 30 * 1000,
  });

/** source_record_ids on any list — powers the "New only" toggle. */
export const useListedLeadIds = (enabled: boolean) => {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ["deals", "listedLeadIds"],
    queryFn: fetchListedLeadIds,
    enabled,
    staleTime: 30 * 1000,
  });
  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: ["deals", "listedLeadIds"] });
  return { ...query, invalidate };
};
